import React from 'react';
import { Link } from 'react-daisyui';
import { useTranslation } from 'react-i18next';
import { type ForType, navigationData } from '../../../data';

const Footer = () => {
    const { t } = useTranslation();
    const headings = navigationData.footer.headings;
    const Navigations = navigationData.footer.topNavigations;
    const socialLinks = navigationData.footer.socialLinks;
    const footerNavigations = navigationData.footer.footerNavigations;
    const currentYear = new Date().getFullYear();

    return (
        <div className="max-w-6xl mx-auto py-8 px-5">
            <div className="w-full grid  grid-cols-1  md:grid-cols-2 lg:grid-cols-3 py-12">
                {Object.keys(Navigations).map((key, i) => (
                    <div key={key}>
                        <p className="md:text-xl text-base  my-5 text-black">{t(headings[i].title, headings[i].defaultTitle)}</p>
                        {(Navigations[key] as ForType).links.map((item, index) => (
                            <Link
                                color="primary"
                                className="hover:no-underline md:text-base text-sm"
                                key={index}
                                href={`${Navigations[key].path}`}
                            >
                                <p className="md:my-4 my-3">{t(item.title, item.defaultTitle)}</p>
                            </Link>
                        ))}
                    </div>
                ))}
            </div>
            <div className="flex flex-wrap justify-between">
                <div className="flex w-full xs:w-auto items-center">
                    <span className="hidden md:inline-block text-stone-500">
                        <span className="font-bold text-stone-500">trades.org</span>
                        {`© ${currentYear}.`}
                    </span>
                    <div className="flex flex-row w-auto md:items-center md:px-3">
                        {footerNavigations.map(({ key, options, path }, index) => (
                            <Link
                                color="primary"
                                key={`footer-navigation-item-${index + 1}`}
                                href={`${path}`}
                                className="px-1 md:px-3 hover:no-underline md:text-base text-sm"
                            >
                                {t(key, options)}
                            </Link>
                        ))}
                    </div>
                </div>
                <div className="flex w-auto my-4 md:my-0">
                    {socialLinks.map(({ href, target, ariaLabel, icon }, index) => (
                        <Link
                            href={href}
                            key={`socialLink-${index + 1}`}
                            target={target}
                            aria-label={ariaLabel}
                            className={`border-0 outline-none cursor-pointer ${index !== 0 ? 'ml-5' : ''}`}
                        >
                            {icon}
                        </Link>
                    ))}
                </div>
            </div>
            <span className="md:hidden inline-block">
                <span className="font-bold">trades.org</span>
                {`© ${currentYear}.`}
            </span>
        </div>
    );
};

export default Footer;
